import EntitySelector from '@components/EntitySelector'

import useBrandGroupPublications from '@hooks/useBrandGroupPublications'
import useCreateBrandGroupPublicationModal from '../../hooks/useCreateBrandGroupPublicationModal'

interface SelectPublicationProps {
  isTopModal: boolean,
  modalHookPayload: ReturnType<typeof useCreateBrandGroupPublicationModal>,
}

const SelectPublication = (props: SelectPublicationProps) => {
  const { isTopModal, modalHookPayload } = props

  const {
    callbacks: {
      addBrandGroupProvider,
    },
    brandGroupPublicationFormPayload,
  } = modalHookPayload

  const {
    entityState: {
      brand_group_id,
      publication_id,
    },
    errors,
    setEntityState,
  } = brandGroupPublicationFormPayload

  const {
    filteredBrandGroupPublications,
  } = useBrandGroupPublications({ filters: { brand_group_id } })

  const assignedPublicationIds = filteredBrandGroupPublications.map(item => item.publication_id)

  return (
    <EntitySelector
      boxProps={{ marginBottom: 'large' }}
      callbacks={{
        selectItem: publication => setEntityState({ publication_id: publication ? publication.id : null }),
      }}
      entityKey="publications"
      errorMessage={errors.publication_id}
      label="* Add Publication"
      searchForwardProps={{
        listAction: (
          // @ts-expect-error TS2741
          <EntitySelector.CreateEntity
            onClick={() => addBrandGroupProvider()}
            strings={{ create: 'Assign Provider to enable' }}
          />
        ),
      }}
      searchRequestOptions={{ assignable_for_brand_group_id: brand_group_id }}
      selectedIds={assignedPublicationIds}
      selectedItemId={publication_id}
      shouldRefetch={isTopModal}
    />
  )
}

export default SelectPublication
